export default () => (
    {
        label: {
            fontSize: '0.65rem'
        }
    }
);
